/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { useNavigate } from "react-router-dom";
import NewStepperForm from "../StepperForm";
import { getValidPersonModelForUser, getValidUserModel } from "utils/model.utils";
import { RoutesConstants } from "@malmur-technologies/medicalsystem-shared";
import { PersonInterface } from "@malmur-technologies/medicalsystem-shared";
import { UserRolesEnum } from "@malmur-technologies/medicalsystem-shared";

/**
 * Dynamic stepper form wrapper for creating new system users.
 * Initializes a new person/user model and configures the stepper form based on user role.
 * Provides post-processing navigation after successful user creation.
 * 
 * Features:
 * - Creates new person model with user credentials
 * - Multi-step user registration workflow
 * - Role-based user creation (admin, receptionist, etc.)
 * - Post-processing handler for navigation
 * - Redirects to users list after completion
 * - Integration with person and user models
 * 
 * User Roles Supported:
 * - ADMIN: System administrator
 * - RECEPTIONIST: Front desk staff
 * - MANAGER: Office manager
 * - Other system roles as defined in UserRolesEnum
 * 
 * Form Flow:
 * 1. PersonForm: Collect demographic information
 * 2. UserForm: Set username, password, email, roles
 * 3. Post-processing: Navigate to user list
 * 
 * Use Cases:
 * - New staff account creation
 * - Administrative user provisioning
 * - Multi-step user onboarding process
 * - Role-based access control setup
 * 
 * @param {Object} props - Component props
 * @param {UserRolesEnum} props.ObjectForEnumType - The user role type to assign
 * @returns {React.ReactElement} The configured stepper form for user creation
 */
const NewDynamicUserStepperForm = ({
  ObjectForEnumType,
}: {
  ObjectForEnumType: UserRolesEnum;
}) => {
  const navigate = useNavigate();

  const person = getValidPersonModelForUser();
  person.user = getValidUserModel();

  const UserStepperForm = NewStepperForm<PersonInterface>;

  const postProcessingHandler = () => {
    navigate(RoutesConstants.NEW_USER);
  };

  return (
    <UserStepperForm
      model={person}
      redirect={RoutesConstants.USER}
      type={ObjectForEnumType}
      postProcessingHandler={postProcessingHandler}
    />
  );
};

export default NewDynamicUserStepperForm;
